export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="logo">
    <svg width="38" height="38" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#14171C" />
      <rect x="9" y="12" width="21" height="17" rx="2.5" fill="#2A2F3A" />
      <rect x="34" y="12" width="21" height="17" rx="2.5" fill="#F4F5F7" />
      <rect x="21.5" y="33" width="21" height="17" rx="2.5" fill="#FFB800" />
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className="font-display block text-2xl font-extrabold uppercase tracking-wide text-pearl">
          AD Brikman
        </span>
        <span className="font-mono block text-[9px] uppercase tracking-[0.3em] text-stonemute">
          Usługi Brukarskie
        </span>
      </span>
    )}
  </span>
);

export default Logo;
